import React from 'react';
import Banner from "./Banner"
import About from './AboutSection';
import SlidingTextOne from '../../components/Common/SlidingTextOne ';
import CounterOne from './CounterOne';
import CTAOne from './CTAOne';
import ContactOne from './ContactOne';
import Team from './Team';
import WeServe from './WeServe';
import FaqOne from './FaqOne';
import ProjectOne from './ProjectOne';
import Blog from './Blog';
import BrandOne from './BrandOne';
import TestimonialOne from './TestimonialOne';
import ServicesOne from './ServicesOne';
import ProjectThree from '../home-3/ProjectThree';
import ContactThree from '../home-4/ContactThree';
import CounterTwo from '../home-2/CounterTwo';
import VideoOne from '../home-3/VideoOne';
import WorkProcess from '../home-3/WorkProcess';
import CtaTwo from '../../components/Common/CtaSection/CtaTwo';
import FooterThree from '../../components/Layout/Footer/FooterStyleThree';
import FooterTwo from '../../components/Layout/Footer/FooterStyleTwo';
import TestimonialTwo from '../home-2/TestimonialTwo';
import videoShape1 from '../../assets/images/backgrounds/updatedteam1.jpeg';

const HomeMain = () => {
	return (
		<React.Fragment>
			<Banner />
			<About />
			<SlidingTextOne />
			<ServicesOne />
			<CounterTwo />
			<ProjectThree />
			<TestimonialTwo />
			<VideoOne videoId={"BCGsMf27oP0"} videoShape1={videoShape1} />
			{/* <WorkProcess /> */}
			<ContactThree />
			{/* <Blog /> */}

			{/* <CTAOne /> */}
			{/* <Team /> */}

			{/* <WeServe /> */}

			{/* <CtaTwo /> */}


			{/* <TestimonialOne /> */}
			{/* <ProjectOne /> */}
			{/* <BrandOne />
			<FaqOne /> */}

		</React.Fragment>
	);
}

export default HomeMain;